// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Inter-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/Inter-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/Inter-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/Inter-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/cerebrisans/CerebriSans-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/fonts/cerebrisans/CerebriSans-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/fonts/cerebrisans/CerebriSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/fonts/cerebrisans/CerebriSans-Medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/fonts/cerebrisans/CerebriSans-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./assets/fonts/cerebrisans/CerebriSans-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./assets/fonts/cerebrisans/CerebriSans-SemiBold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./assets/fonts/cerebrisans/CerebriSans-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./assets/fonts/cerebrisans/CerebriSans-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./assets/fonts/cerebrisans/CerebriSans-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
    body{
        /* @apply overflow-hidden */
    }
    html {
  font-family: Inter, Cerebri Sans;
}
    .card > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
  --tw-divide-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-divide-opacity, 1));
}
    .card {
  border-radius: 0.375rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
    .card-body {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 14px;
  padding-bottom: 14px;
  padding-bottom: 8rem;
}
    .card-title {
  font-weight: 500;
}
    .nav-link {
  margin-top: 2px;
  margin-bottom: 2px;
  display: inline-block;
  width: 100%;
  padding-top: 14px;
  padding-bottom: 14px;
  padding-left: 2rem;
  padding-right: 12px;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  opacity: 0.9;
}
    .nav-link:hover {
  background-color: rgb(22 101 52 / var(--tw-bg-opacity, 1));
  --tw-bg-opacity: 0.8;
}
    .nav-link.active {
  border-left-width: 4px;
  border-left-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
  --tw-border-opacity: 0.4;
  background-color: rgb(22 101 52 / var(--tw-bg-opacity, 1));
  --tw-bg-opacity: 0.3;
  padding-left: 27px;
  opacity: 1;
}
    .nav-link .fa {
  margin-right: 12px;
  margin-top: 5px;
  opacity: 0.8;
}
    .sub-nav-link {
  display: inline-block;
  width: 100%;
  padding-top: 9px;
  padding-bottom: 9px;
  padding-left: 2rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  opacity: 0.9;
}
    .sub-nav-link:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(78 185 105 / var(--tw-bg-opacity, 1));
}
    .sub-nav-link.active {
  border-left-width: 5px;
  --tw-border-opacity: 1;
  border-left-color: rgb(5 26 53 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(252 231 76 / var(--tw-bg-opacity, 1));
  padding-left: 43px;
  opacity: 1;
}

    .form-input-1 {
  display: block;
  width: 100%;
  border-radius: 0.5rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
  padding: 0.625rem;
  padding-left: 2.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

    .form-input-1:focus {
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(34 197 94 / var(--tw-ring-opacity, 1));
}
    .form-label-1 {
  margin-bottom: 8px;
  margin-left: 2px;
  display: block;
  font-size: 0.875rem;
  line-height: 1.25rem;
  opacity: 0.8;
}
    .form-input-1-icon {
  height: 17px;
  width: 17px;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
  --tw-text-opacity: 0.6;
}
    tbody td {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 24px;
  padding-bottom: 24px;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
    tbody tr {
  border-bottom-width: 1px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
    thead {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}

    thead th {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 16px;
  padding-bottom: 16px;
  font-weight: 400;
}
    .modal {
  position: fixed;
  left: 0px;
  top: 0px;
  z-index: 2;
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  overflow: auto;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
  --tw-bg-opacity: 0.3;
  padding-top: 2.5rem;
}
    .modal-content {
  height: fit-content;
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding: 24px;
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
    @media (min-width: 1536px) {

  .modal-md {
    width: 33.333333%;
  }
}
    @media (max-width: 1535px) {

  .modal-md {
    width: 33.333333%;
  }
}
    @media (max-width: 1279px) {

  .modal-md {
    width: 33.333333%;
  }
}
    @media (max-width: 1023px) {

  .modal-md {
    width: 66.666667%;
  }
}
    @media (max-width: 767px) {

  .modal-md {
    width: 66.666667%;
  }
}
    @media (max-width: 639px) {

  .modal-md {
    width: 66.666667%;
  }
}

    .form-input-2 {
  display: block;
  width: 100%;
  border-radius: 0.375rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
  padding: 0.625rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

    .form-input-2:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

    .form-input-2:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
    .danger-btn-1 {
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
  padding-left: 32px;
  padding-right: 32px;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
    .danger-btn-1:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(153 27 27 / var(--tw-bg-opacity, 1));
}
    .danger-btn-1:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
    .danger-btn-1:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(252 231 76 / var(--tw-bg-opacity, 1));
}
    .prim-btn-login {
  width: 100%;
  border-radius: 0.5rem;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  --tw-bg-opacity: 0.2;
  padding-left: 32px;
  padding-right: 32px;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
    .prim-btn-login:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(78 185 105 / var(--tw-bg-opacity, 1));
}
    .prim-btn-login:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
    .prim-btn-login:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(252 231 76 / var(--tw-bg-opacity, 1));
  opacity: 0.8;
}
    
    .prim-btn-2 {
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
  padding-left: 32px;
  padding-right: 32px;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  opacity: 0.9;
}
    
    .prim-btn-2:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(22 101 52 / var(--tw-bg-opacity, 1));
}
    
    .prim-btn-2:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
    
    .prim-btn-2:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(78 185 105 / var(--tw-bg-opacity, 1));
}
    .btn-light {
  display: inline-flex;
  align-items: center;
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
  padding-left: 32px;
  padding-right: 32px;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  text-align: center;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
    .btn-light:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
    .btn-light:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(243 244 246 / var(--tw-ring-opacity, 1));
}

    .btn-secondary-1 {
  border-radius: 0.5rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  padding-left: 32px;
  padding-right: 32px;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

    .btn-secondary-1:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(78 185 105 / var(--tw-text-opacity, 1));
}

    .btn-secondary-1:focus {
  z-index: 10;
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(229 231 235 / var(--tw-ring-opacity, 1));
}
    .tab-inactive {
  display: inline-block;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  border-bottom-width: 2px;
  border-color: transparent;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 24px;
  padding-right: 24px;
}
    .tab-inactive:hover {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
    .nav-link.tab-active {
  border-left-width: 4px;
  border-left-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
  --tw-border-opacity: 0.4;
  background-color: rgb(22 101 52 / var(--tw-bg-opacity, 1));
  --tw-bg-opacity: 0.3;
  padding-left: 27px;
  opacity: 1;
}
    .sub-nav-link.tab-active {
  border-left-width: 5px;
  --tw-border-opacity: 1;
  border-left-color: rgb(5 26 53 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(252 231 76 / var(--tw-bg-opacity, 1));
  padding-left: 43px;
  opacity: 1;
}
    .tab-active {
  display: inline-block;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  border-bottom-width: 4px;
  --tw-border-opacity: 1;
  border-color: rgb(78 185 105 / var(--tw-border-opacity, 1));
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 24px;
  padding-right: 24px;
  --tw-text-opacity: 1;
  color: rgb(78 185 105 / var(--tw-text-opacity, 1));
}
    .nav-dropdown-item {
  cursor: pointer;
  padding-left: 16px;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-right: 48px;
}
    .nav-dropdown-item:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.container {
  width: 100%;
  padding-right: 2rem;
  padding-left: 2rem;
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.left-0 {
  left: 0px;
}
.right-0 {
  right: 0px;
}
.right-4 {
  right: 24px;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.mx-2 {
  margin-left: 12px;
  margin-right: 12px;
}
.mx-4 {
  margin-left: 24px;
  margin-right: 24px;
}
.-mb-px {
  margin-bottom: -1px;
}
.mb-1 {
  margin-bottom: 8px;
}
.mb-2 {
  margin-bottom: 12px;
}
.mb-3 {
  margin-bottom: 16px;
}
.ml-2 {
  margin-left: 12px;
}
.ml-\\[270px\\] {
  margin-left: 270px;
}
.mr-2 {
  margin-right: 12px;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 12px;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-3 {
  margin-top: 16px;
}
.mt-4 {
  margin-top: 24px;
}
.mt-5 {
  margin-top: 32px;
}
.mt-8 {
  margin-top: 2rem;
}
.block {
  display: block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.hidden {
  display: none;
}
.h-0 {
  height: 0px;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-16 {
  height: 4rem;
}
.h-20 {
  height: 5rem;
}
.h-3 {
  height: 16px;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-44 {
  height: 11rem;
}
.h-64 {
  height: 16rem;
}
.h-8 {
  height: 2rem;
}
.h-auto {
  height: auto;
}
.h-fit {
  height: fit-content;
}
.h-full {
  height: 100%;
}
.h-max {
  height: max-content;
}
.h-screen {
  height: 100vh;
}
.min-h-\\[80px\\] {
  min-height: 80px;
}
.min-h-half-screen {
  min-height: 50vh;
}
.min-h-screen {
  min-height: 100vh;
}
.w-1\\/2 {
  width: 50%;
}
.w-10 {
  width: 2.5rem;
}
.w-2\\/3 {
  width: 66.666667%;
}
.w-3 {
  width: 16px;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-3\\/5 {
  width: 60%;
}
.w-32 {
  width: 8rem;
}
.w-4\\/6 {
  width: 66.666667%;
}
.w-5 {
  width: 32px;
}
.w-8 {
  width: 2rem;
}
.w-\\[270px\\] {
  width: 270px;
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.w-screen {
  width: 100vw;
}
.min-w-\\[13rem\\] {
  min-width: 13rem;
}
.min-w-\\[270px\\] {
  min-width: 270px;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[300px\\] {
  max-width: 300px;
}
.flex-grow {
  flex-grow: 1;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-pointer {
  cursor: pointer;
}
.list-none {
  list-style-type: none;
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-center {
  align-items: center;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-1 {
  gap: 8px;
}
.gap-2 {
  gap: 12px;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-y-auto {
  overflow-y: auto;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-none {
  border-radius: 0px;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-l-0 {
  border-left-width: 0px;
}
.border-r-0 {
  border-right-width: 0px;
}
.border-t-0 {
  border-top-width: 0px;
}
.border-t-\\[1px\\] {
  border-top-width: 1px;
}
.border-dashed {
  border-style: dashed;
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.border-opacity-60 {
  --tw-border-opacity: 0.6;
}
.bg-body-bg {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-green-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}
.bg-green-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 101 52 / var(--tw-bg-opacity, 1));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-opacity-100 {
  --tw-bg-opacity: 1;
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-opacity-70 {
  --tw-bg-opacity: 0.7;
}
.fill-black {
  fill: #000;
}
.fill-gray-700 {
  fill: #374151;
}
.p-0 {
  padding: 0px;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-16 {
  padding-left: 4rem;
  padding-right: 4rem;
}
.px-2 {
  padding-left: 12px;
  padding-right: 12px;
}
.px-5 {
  padding-left: 32px;
  padding-right: 32px;
}
.py-1 {
  padding-top: 8px;
  padding-bottom: 8px;
}
.py-2 {
  padding-top: 12px;
  padding-bottom: 12px;
}
.py-4 {
  padding-top: 24px;
  padding-bottom: 24px;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-20 {
  padding-bottom: 5rem;
}
.pb-4 {
  padding-bottom: 24px;
}
.pb-6 {
  padding-bottom: 48px;
}
.pl-1 {
  padding-left: 8px;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-\\[2px\\] {
  padding-left: 2px;
}
.pl-\\[8px\\] {
  padding-left: 8px;
}
.pl-edge-space {
  padding-left: 2rem;
}
.pr-\\[8px\\] {
  padding-right: 8px;
}
.pr-edge-space {
  padding-right: 2rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-14 {
  padding-top: 3.5rem;
}
.pt-4 {
  padding-top: 24px;
}
.pt-5 {
  padding-top: 32px;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-gray-200 {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-prim-yellow {
  --tw-text-opacity: 1;
  color: rgb(252 231 76 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.accent-green-700 {
  accent-color: #15803d;
}
.opacity-80 {
  opacity: 0.8;
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}


/* @font-face {
    font-family: 'Inter';
    src: url('./assets/fonts/Inter-Regular.ttf') format('truetype');
} */

@font-face {
    font-family: 'Inter';
    font-weight: 300;
    font-style: normal;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

@font-face {
    font-family: 'Inter';
    font-weight: 400;
    font-style: normal;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}
  
@font-face {
    font-family: 'Inter';
    font-weight: 500;
    font-style: normal;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}

@font-face {
    font-family: 'Inter';
    font-weight: 600;
    font-style: normal;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}

@font-face {
    font-family: 'Inter';
    font-weight: 700;
    font-style: normal;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
}

@font-face {
    font-family: 'Cerebri Sans';
    font-weight: 400;
    font-style: normal;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype")
  }
  
  @font-face {
    font-family: 'Cerebri Sans';
    font-weight: 500;
    font-style: normal;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("truetype")
  }
  
  @font-face {
    font-family: 'Cerebri Sans';
    font-weight: 600;
    font-style: normal;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("truetype")
  }

  @font-face {
    font-family: 'Cerebri Sans';
    font-weight: 700;
    font-style: normal;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("truetype")
  }
.progressbar-text {
  position: absolute;
  top: 0px;
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}
.hover\\:bg-green-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}
@media (min-width: 1536px) {

  .\\33xl\\:h-28 {
    height: 7rem;
  }

  .\\33xl\\:w-1\\/3 {
    width: 33.333333%;
  }

  .\\33xl\\:w-4\\/6 {
    width: 66.666667%;
  }

  .\\33xl\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 1535px) {

  .\\32xl\\:h-28 {
    height: 7rem;
  }

  .\\32xl\\:w-1\\/3 {
    width: 33.333333%;
  }

  .\\32xl\\:w-4\\/6 {
    width: 66.666667%;
  }

  .\\32xl\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 1279px) {

  .xl\\:h-28 {
    height: 7rem;
  }

  .xl\\:w-1\\/3 {
    width: 33.333333%;
  }

  .xl\\:w-4\\/6 {
    width: 66.666667%;
  }

  .xl\\:min-w-full {
    min-width: 100%;
  }

  .xl\\:max-w-full {
    max-width: 100%;
  }

  .xl\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 1023px) {

  .lg\\:h-14 {
    height: 3.5rem;
  }

  .lg\\:w-full {
    width: 100%;
  }

  .lg\\:min-w-desktop {
    min-width: 1280px;
  }

  .lg\\:max-w-full {
    max-width: 100%;
  }

  .lg\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}
@media (max-width: 767px) {

  .md\\:h-14 {
    height: 3.5rem;
  }

  .md\\:w-full {
    width: 100%;
  }

  .md\\:min-w-desktop {
    min-width: 1280px;
  }

  .md\\:max-w-desktop {
    max-width: 1280px;
  }

  .md\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}
@media (max-width: 639px) {

  .sm\\:mb-0 {
    margin-bottom: 0px;
  }

  .sm\\:h-14 {
    height: 3.5rem;
  }

  .sm\\:w-full {
    width: 100%;
  }

  .sm\\:min-w-desktop {
    min-width: 1280px;
  }

  .sm\\:max-w-desktop {
    max-width: 1280px;
  }

  .sm\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
}
@media (prefers-color-scheme: dark) {

  .dark\\:text-gray-400 {
    --tw-text-opacity: 1;
    color: rgb(156 163 175 / var(--tw-text-opacity, 1));
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;IAAd;QAAA,2BAAc;IAAA;IAAd;EAAA;AAAc;IAAd;EAAA,wBAAc;EAAd,kEAAc;EAAd,2DAAc;EAAd,sBAAc;EAAd;AAAc;IAAd;EAAA,uBAAc;EAAd,iBAAc;EAAd,sBAAc;EAAd,4DAAc;EAAd,kBAAc;EAAd;AAAc;IAAd;EAAA,kBAAc;EAAd,mBAAc;EAAd,iBAAc;EAAd,oBAAc;EAAd;AAAc;IAAd;EAAA;AAAc;IAAd;EAAA,eAAc;EAAd,kBAAc;EAAd,qBAAc;EAAd,WAAc;EAAd,iBAAc;EAAd,oBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,oBAAc;EAAd,mDAAc;EAAd;AAAc;IAAd;EAAA,0DAAc;EAAd;AAAc;IAAd;EAAA,sBAAc;EAAd,iEAAc;EAAd,wBAAc;EAAd,0DAAc;EAAd,oBAAc;EAAd,kBAAc;EAAd;AAAc;IAAd;EAAA,kBAAc;EAAd,eAAc;EAAd;AAAc;IAAd;EAAA,qBAAc;EAAd,WAAc;EAAd,gBAAc;EAAd,mBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,oBAAc;EAAd,gBAAc;EAAd;AAAc;IAAd;EAAA,kBAAc;EAAd;AAAc;IAAd;EAAA,sBAAc;EAAd,sBAAc;EAAd,6DAAc;EAAd,kBAAc;EAAd,2DAAc;EAAd,kBAAc;EAAd;AAAc;;IAAd;EAAA,cAAc;EAAd,WAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd,sBAAc;EAAd,4DAAc;EAAd,kBAAc;EAAd,4DAAc;EAAd,iBAAc;EAAd,oBAAc;EAAd,mBAAc;EAAd,oBAAc;EAAd,oBAAc;EAAd;AAAc;;IAAd;EAAA,sBAAc;EAAd,0DAAc;EAAd,oBAAc;EAAd;AAAc;IAAd;EAAA,kBAAc;EAAd,gBAAc;EAAd,cAAc;EAAd,mBAAc;EAAd,oBAAc;EAAd;AAAc;IAAd;EAAA,YAAc;EAAd,WAAc;EAAd,6CAAc;EAAd;AAAc;IAAd;EAAA,kBAAc;EAAd,mBAAc;EAAd,iBAAc;EAAd,oBAAc;EAAd,mBAAc;EAAd,oBAAc;EAAd,oBAAc;EAAd;AAAc;IAAd;EAAA,wBAAc;EAAd,kBAAc;EAAd;AAAc;IAAd;EAAA,kBAAc;EAAd,4DAAc;EAAd,mBAAc;EAAd,oBAAc;EAAd,oBAAc;EAAd;AAAc;;IAAd;EAAA,kBAAc;EAAd,mBAAc;EAAd,iBAAc;EAAd,oBAAc;EAAd;AAAc;IAAd;EAAA,eAAc;EAAd,SAAc;EAAd,QAAc;EAAd,UAAc;EAAd,aAAc;EAAd,YAAc;EAAd,WAAc;EAAd,uBAAc;EAAd,cAAc;EAAd,sDAAc;EAAd,oBAAc;EAAd;AAAc;IAAd;EAAA,mBAAc;EAAd,sBAAc;EAAd,kBAAc;EAAd,4DAAc;EAAd,aAAc;EAAd,0EAAc;EAAd,8FAAc;EAAd;AAAc;IAAd;;EAAA;IAAA;EAAc;AAAA;IAAd;;EAAA;IAAA;EAAc;AAAA;IAAd;;EAAA;IAAA;EAAc;AAAA;IAAd;;EAAA;IAAA;EAAc;AAAA;IAAd;;EAAA;IAAA;EAAc;AAAA;IAAd;;EAAA;IAAA;EAAc;AAAA;;IAAd;EAAA,cAAc;EAAd,WAAc;EAAd,uBAAc;EAAd,iBAAc;EAAd,sBAAc;EAAd,4DAAc;EAAd,iBAAc;EAAd,mBAAc;EAAd,oBAAc;EAAd,oBAAc;EAAd,gDAAc;EAAd,8BAAc;EAAd,mBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd;AAAc;;IAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd;AAAc;;IAAd;EAAA,kBAAc;EAAd;AAAc;IAAd;EAAA,qBAAc;EAAd,kBAAc;EAAd,0DAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,oBAAc;EAAd,gBAAc;EAAd,oBAAc;EAAd;AAAc;IAAd;EAAA,kBAAc;EAAd;AAAc;IAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd;AAAc;IAAd;EAAA,kBAAc;EAAd;AAAc;IAAd;EAAA,WAAc;EAAd,qBAAc;EAAd,4DAAc;EAAd,oBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,oBAAc;EAAd,gBAAc;EAAd,oBAAc;EAAd;AAAc;IAAd;EAAA,kBAAc;EAAd;AAAc;IAAd;EAAA,8BAAc;EAAd;AAAc;IAAd;EAAA,kBAAc;EAAd,2DAAc;EAAd;AAAc;;IAAd;EAAA,qBAAc;EAAd,kBAAc;EAAd,0DAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,oBAAc;EAAd,gBAAc;EAAd,oBAAc;EAAd,mDAAc;EAAd;AAAc;;IAAd;EAAA,kBAAc;EAAd;AAAc;;IAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd;AAAc;;IAAd;EAAA,kBAAc;EAAd;AAAc;IAAd;EAAA,oBAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,kBAAc;EAAd,4DAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,oBAAc;EAAd,gBAAc;EAAd,oBAAc;EAAd;AAAc;IAAd;EAAA,kBAAc;EAAd;AAAc;IAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,4FAAc;EAAd,oBAAc;EAAd;AAAc;;IAAd;EAAA,qBAAc;EAAd,iBAAc;EAAd,sBAAc;EAAd,4DAAc;EAAd,kBAAc;EAAd,4DAAc;EAAd,qBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,oBAAc;EAAd,gBAAc;EAAd,oBAAc;EAAd;AAAc;;IAAd;EAAA,kBAAc;EAAd,4DAAc;EAAd,oBAAc;EAAd;AAAc;;IAAd;EAAA,WAAc;EAAd,8BAAc;EAAd,mBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,4FAAc;EAAd,oBAAc;EAAd;AAAc;IAAd;EAAA,qBAAc;EAAd,8BAAc;EAAd,+BAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,iBAAc;EAAd,oBAAc;EAAd,kBAAc;EAAd;AAAc;IAAd;EAAA,sBAAc;EAAd,4DAAc;EAAd,oBAAc;EAAd;AAAc;IAAd;EAAA,sBAAc;EAAd,iEAAc;EAAd,wBAAc;EAAd,0DAAc;EAAd,oBAAc;EAAd,kBAAc;EAAd;AAAc;IAAd;EAAA,sBAAc;EAAd,sBAAc;EAAd,6DAAc;EAAd,kBAAc;EAAd,2DAAc;EAAd,kBAAc;EAAd;AAAc;IAAd;EAAA,qBAAc;EAAd,8BAAc;EAAd,+BAAc;EAAd,wBAAc;EAAd,sBAAc;EAAd,2DAAc;EAAd,iBAAc;EAAd,oBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,oBAAc;EAAd;AAAc;IAAd;EAAA,eAAc;EAAd,kBAAc;EAAd,iBAAc;EAAd,oBAAc;EAAd;AAAc;IAAd;EAAA,kBAAc;EAAd;AAAc;AACd;EAAA,WAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;;;AAGnB;;;GAGG;;AAEH;IACI,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,+DAA+D;AACnE;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,+DAA8D;AAClE;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,+DAA8D;AAClE;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,+DAAgE;AACpE;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,+DAA4D;AAChE;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;IAClB,4CAA8D;IAC9D;EACF;;EAEA;IACE,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;IAClB,4CAA6D;IAC7D;EACF;;EAEA;IACE,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;IAClB,6CAA+D;IAC/D;EACF;;EAEA;IACE,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;IAClB,6CAA2D;IAC3D;EACF;AAiIE;EAAA,kBAA6E;EAA7E,QAA6E;EAA7E,aAA6E;EAA7E,YAA6E;EAA7E,WAA6E;EAA7E,sBAA6E;EAA7E,uBAA6E;EAA7E;AAA6E;AA5MjF;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;;EAAA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;AAAA;AA9MA;;EAAA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;AAAA;AA9MA;;EAAA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;AAAA;AA9MA;;EAAA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;AAAA;AA9MA;;EAAA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;AAAA;AA9MA;;EAAA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;AAAA;AA9MA;;EAAA;IAAA,oBA8MA;IA9MA;EA8MA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n\n/* @font-face {\n    font-family: 'Inter';\n    src: url('./assets/fonts/Inter-Regular.ttf') format('truetype');\n} */\n\n@font-face {\n    font-family: 'Inter';\n    font-weight: 300;\n    font-style: normal;\n    src: url('./assets/fonts/Inter-Regular.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Inter';\n    font-weight: 400;\n    font-style: normal;\n    src: url('./assets/fonts/Inter-Medium.ttf') format('truetype');\n}\n  \n@font-face {\n    font-family: 'Inter';\n    font-weight: 500;\n    font-style: normal;\n    src: url('./assets/fonts/Inter-Medium.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Inter';\n    font-weight: 600;\n    font-style: normal;\n    src: url('./assets/fonts/Inter-SemiBold.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Inter';\n    font-weight: 700;\n    font-style: normal;\n    src: url('./assets/fonts/Inter-Bold.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: 'Cerebri Sans';\n    font-weight: 400;\n    font-style: normal;\n    src: url('./assets/fonts/cerebrisans/CerebriSans-Regular.eot');\n    src: url('./assets/fonts/cerebrisans/CerebriSans-Regular.eot?#iefix') format(\"embedded-opentype\"), url('./assets/fonts/cerebrisans/CerebriSans-Regular.woff') format(\"woff\"), url('./assets/fonts/cerebrisans/CerebriSans-Regular.ttf') format(\"truetype\")\n  }\n  \n  @font-face {\n    font-family: 'Cerebri Sans';\n    font-weight: 500;\n    font-style: normal;\n    src: url('./assets/fonts/cerebrisans/CerebriSans-Medium.eot');\n    src: url('./assets/fonts/cerebrisans/CerebriSans-Medium.eot?#iefix') format(\"embedded-opentype\"), url('./assets/fonts/cerebrisans/CerebriSans-Medium.woff') format(\"woff\"), url('./assets/fonts/cerebrisans/CerebriSans-Medium.ttf') format(\"truetype\")\n  }\n  \n  @font-face {\n    font-family: 'Cerebri Sans';\n    font-weight: 600;\n    font-style: normal;\n    src: url('./assets/fonts/cerebrisans/CerebriSans-SemiBold.eot');\n    src: url('./assets/fonts/cerebrisans/CerebriSans-SemiBold.eot?#iefix') format(\"embedded-opentype\"), url('./') format(\"woff\"), url('./assets/fonts/cerebrisans/CerebriSans-SemiBold.ttf') format(\"truetype\")\n  }\n\n  @font-face {\n    font-family: 'Cerebri Sans';\n    font-weight: 700;\n    font-style: normal;\n    src: url('./assets/fonts/cerebrisans/CerebriSans-Bold.eot');\n    src: url('./assets/fonts/cerebrisans/CerebriSans-Bold.eot?#iefix') format(\"embedded-opentype\"), url('./') format(\"woff\"), url('./assets/fonts/cerebrisans/CerebriSans-Bold.ttf') format(\"truetype\")\n  }\n\n@layer base {\n    body{\n        /* @apply overflow-hidden */\n    }\n    html{\n        @apply font-inter\n    }\n    .card{\n        @apply border border-gray-100  divide-y divide-gray-100 bg-white rounded-md\n    }\n    .card-header{\n        @apply border-b-gray-100 px-2 py-[10px]\n    }\n    .card-body{\n        @apply px-3 py-[14px]  pb-32\n    }\n    .card-title{\n        @apply font-medium\n    }\n    .search-input{\n        @apply bg-gray-100 h-8 px-2 rounded-md w-full transition-all duration-700 focus:flex-grow focus:outline-none focus:ring-0 outline-none ring-0\n    }\n    .nav-link{\n        @apply text-white pl-edge-space py-[14px] my-[2px] opacity-90 inline-block hover:bg-green-800 hover:bg-opacity-80 w-full  pr-2 \n    }\n    .nav-link.active{\n        @apply bg-green-800 bg-opacity-30  border-l-[4px] border-l-white border-opacity-40 opacity-100 pl-[27px]\n    }\n    .nav-link .fa{\n        @apply opacity-80 mr-2 mt-[5px]\n    }\n    .sub-nav-link{\n        @apply pl-edge-space py-[9px] text-sm font-normal inline-block  hover:bg-prim-green w-full opacity-90\n    }\n    .sub-nav-link.active{\n        @apply bg-prim-yellow border-l-[5px] border-l-prim-color opacity-100 pl-[43px]\n    }\n\n    .form-input-1{\n        @apply bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full pl-10 p-2.5 \n        /* @apply bg-white border bg-opacity-20 text-white text-[13px] rounded block w-full p-1  focus:outline-none text-opacity-80 */\n    }\n    .form-label-1{\n        @apply block mb-1 ml-[2px] text-sm  opacity-80\n    }\n    .form-input-1-icon{\n        @apply w-[17px] h-[17px] text-black text-opacity-60\n    }\n    tbody td{\n        @apply px-3 py-4 text-gray-500  text-sm\n    }\n    tbody tr{\n        @apply bg-white border-b \n    }\n    thead{\n        @apply text-gray-700  bg-gray-50 text-sm\n    }\n\n    thead th{\n        @apply px-3 py-3 font-normal \n    }\n    .modal{\n        @apply fixed z-[2] pt-10 left-0 top-0 w-full h-full overflow-auto bg-black bg-opacity-30 flex justify-center \n    }\n    .modal-content{\n        @apply h-fit bg-white rounded shadow p-4\n    }\n    .modal-md{\n        @apply sm:w-2/3 md:w-2/3 lg:w-2/3 xl:w-1/3 2xl:w-1/3 3xl:w-1/3\n    }\n    .modal-lg{\n        @apply sm:w-3/4 md:w-3/4 lg:w-3/4 xl:w-2/4 2xl:w-2/4 3xl:w-2/4\n    }\n\n    .form-input-2{\n        @apply border border-gray-300 text-gray-900 text-sm rounded-md  block w-full p-2.5 focus:outline-none focus:ring-0 outline-none ring-0 disabled:bg-gray-100\n    }\n    .danger-btn-1{\n        @apply text-white bg-red-600 hover:bg-red-800 focus:ring-4 font-medium rounded-lg text-sm px-5 py-2.5 focus:outline-none disabled:bg-prim-yellow \n    }\n    .prim-btn-login{\n        @apply text-white  bg-white bg-opacity-20 hover:bg-prim-green font-medium rounded-lg text-sm px-5 py-2.5 focus:outline-none w-full disabled:bg-prim-yellow disabled:opacity-80\n    }\n    .prim-btn-1{\n        @apply text-black bg-prim-yellow hover:bg-prim-green focus:ring-4 font-medium rounded-lg text-sm px-5 py-2.5 focus:outline-none disabled:bg-prim-yellow \n    }\n    \n    .prim-btn-2{\n        @apply text-white opacity-90 bg-green-700 hover:bg-green-800 focus:ring-4 font-medium rounded-lg text-sm px-5 py-2.5 focus:outline-none disabled:bg-prim-green \n    }\n    .btn-light{\n        @apply text-black bg-gray-100 hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center\n    }\n\n    .btn-secondary-1{\n        @apply py-2.5 px-5  text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-prim-green focus:z-10 focus:ring-4 focus:ring-gray-200\n    }\n    .dropdown{\n        @apply z-10 absolute  bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700\n    }\n    .dropdown-item{\n        @apply block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white\n    }\n    \n    .dropdown-content{\n        @apply py-2 text-sm text-gray-700 dark:text-gray-200\n    }\n    .badge-success{\n        @apply bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5   rounded \n    }\n    .badge-failed{\n        @apply bg-red-100 text-red-800 text-xs font-medium  px-2.5 py-0.5   rounded \n    }\n    .badge-pending{\n        @apply bg-gray-100 text-gray-800 text-xs font-medium  px-2.5 py-0.5   rounded \n    }\n    .tab-inactive{\n        @apply inline-block  py-2 px-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300\n    }\n    .tab-active{\n        @apply inline-block py-2 px-4 text-prim-green border-b-4 border-prim-green rounded-t-lg active \n    }\n    .nav-dropdown-item{\n        @apply  px-3 pr-6 py-2 hover:bg-gray-100 cursor-pointer\n    }\n}\n.progressbar-text{\n    @apply absolute  w-full flex flex-col text-center justify-center  top-0 h-full\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
